import type { TovVersionResponse } from "contracts/api/client-tov/version.responses";
import { createResource, createSignal, For, Show } from "solid-js";
import { api } from "../../store/api";

export function EvidencePanel(props: {
  clientId: string;
  version: TovVersionResponse;
}) {
  const [sources] = createResource(
    () => [props.clientId, props.version.id] as const,
    ([clientId, versionId]) => api.tov.listSources(clientId, versionId),
  );
  const [sourceId, setSourceId] = createSignal<string | null>(null);
  const [chunks] = createResource(sourceId, (id) =>
    api.tov.chunks(props.clientId, id),
  );
  return (
    <section class="tov-group">
      <h2 class="tov-group-title">Evidence</h2>
      <div class="tov-evidence-layout">
        <div class="tov-evidence-list">
          <For each={sources()?.sources ?? []}>
            {(source) => (
              <button
                type="button"
                class={`tov-source-row ${
                  source.id === sourceId() ? "is-active" : ""
                }`}
                onClick={() => setSourceId(source.id)}
              >
                <span>{source.title}</span>
                <span class="tov-chip muted">{source.status}</span>
              </button>
            )}
          </For>
        </div>
        <div class="tov-evidence-results">
          <For
            each={chunks()?.chunks ?? []}
            fallback={<p class="tov-sub">Select a source.</p>}
          >
            {(chunk) => (
              <article class="tov-evidence-chunk">
                <div class="tov-tags">
                  <span class="tov-chip muted">chunk {chunk.chunkIndex}</span>
                  <Show when={chunk.pageStart}>
                    <span class="tov-chip muted">page {chunk.pageStart}</span>
                  </Show>
                </div>
                <p>{chunk.content}</p>
              </article>
            )}
          </For>
        </div>
      </div>
      <LinkedEvidence version={props.version} />
    </section>
  );
}

function LinkedEvidence(props: { version: TovVersionResponse }) {
  const rows = () =>
    [
      ...props.version.traits.map((row) => ({
        label: row.label,
        links: row.linkedEvidence,
      })),
      ...props.version.rules.map((row) => ({
        label: row.title,
        links: row.linkedEvidence,
      })),
      ...props.version.lexicon.map((row) => ({
        label: row.term,
        links: row.linkedEvidence,
      })),
      ...props.version.visualGuidelines.map((row) => ({
        label: row.title,
        links: row.linkedEvidence,
      })),
    ].filter((row) => row.links.length > 0);
  return (
    <div class="tov-linked-evidence">
      <For each={rows()}>
        {(row) => (
          <article>
            <strong>{row.label}</strong>
            <For each={row.links}>
              {(link) => (
                <p class="tov-sub">
                  {link.relationship}: {link.evidence.claim} (
                  {link.evidence.locator})
                </p>
              )}
            </For>
          </article>
        )}
      </For>
    </div>
  );
}
